import { useSyncExternalStore } from 'react';
import { Icon, type IconName } from './Icon';

interface ToastItem { id: number; message: string; icon: IconName }

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(message: string, icon: IconName = 'info') {
  const id = ++seq;
  items = [...items, { id, message, icon }];
  emit();
  setTimeout(() => { items = items.filter((t) => t.id !== id); emit(); }, 4200);
}

export function Toaster() {
  const list = useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => items
  );
  return (
    <div className="toast-host" role="status" aria-live="polite">
      {list.map((t) => <div key={t.id} className="toast"><Icon name={t.icon} /><span>{t.message}</span></div>)}
    </div>
  );
}
